const base = "";

export async function api<T>(
  path: string,
  init?: RequestInit,
): Promise<{
  ok: boolean;
  data?: T;
  error?: string;
  status: number;
  /** JSON body on error responses (hint, missing, etc.) */
  errorBody?: Partial<T> & Record<string, unknown>;
}> {
  const headers: Record<string, string> = {
    ...(init?.headers as Record<string, string>),
  };
  if (init?.body && typeof init.body === "string" && !headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }

  const res = await fetch(`${base}${path}`, {
    ...init,
    credentials: "include",
    headers,
  });
  const status = res.status;
  let data: unknown;
  try {
    data = await res.json();
  } catch {
    data = {};
  }
  const obj = data as { error?: string };
  if (!res.ok) {
    return {
      ok: false,
      error: obj.error || res.statusText,
      status,
      errorBody: data as Record<string, unknown>,
    };
  }
  return { ok: true, data: data as T, status };
}
